import { default as JSCookies, CookieAttributes } from 'js-cookie';

import isBrowser from '../isBrowser';
import { isLucidMarketingDomain } from '../validators/regex';
import { Metatag } from '../../types/template';

const getCookie = (name: string) => {
  const cookie = JSCookies.get(name) || undefined;

  return cookie;
};

export const setCookie = (name: string, value: string, options = {} as CookieAttributes) => {
  const cookie = JSCookies.set(name, value, options);

  return cookie;
};

export const initialLandingPage = () => {
  const { origin, pathname } = window.location;
  const url = `${origin}${pathname}`;
  const cookie = getCookie('initialLandingPage');
  let sessionInitialLandingPage = '';

  if (!window.sessionStorage.initialLandingPage && !cookie) {
    setCookie('initialLandingPage', url);
    return (window.sessionStorage.initialLandingPage = url);
  }

  if (window.sessionStorage.initialLandingPage) {
    sessionInitialLandingPage = url;
  }

  if (url.match(isLucidMarketingDomain) && cookie && !sessionInitialLandingPage) {
    setCookie('initialLandingPage', url);
    return (window.sessionStorage.initialLandingPage = url);
  }
};

export const getUsernameCookie = () => {
  if (isBrowser()) {
    return window.atob(getCookie('username') || '');
  }

  return undefined;
};

export const setMetatagCookies = (metatags?: Metatag[] | null) => {
  if (isBrowser()) {
    const setCookies = metatags?.find(tag => tag.key === 'set-cookie');
    const cookieData =
      setCookies?.value && setCookies?.value.match(/=/gi) ? setCookies?.value.split('=') : [setCookies?.value];

    if (cookieData && cookieData[0]) {
      setCookie(cookieData[0], cookieData[1] || 'true');
    }
  }
};

export { JSCookies as Cookies };
export default getCookie;
